import queryString from "qs";

/**
 * The applications list request's query string. Without `paging` it is the
 * list query the application page's next/previous walks (BSCPF-6998): the
 * same list in the same order, carried in router state on row open.
 */
export const buildApplicationsListQuery = (
  listParams: Record<string, unknown>,
  paging?: { page: string | number; per_page: string | number }
) =>
  queryString.stringify(
    { ...paging, ...listParams },
    { arrayFormat: "brackets" }
  );
